import mediator from "@tvg/mediator";

export const favoriteInteractionEvent = ({
  isFavorite
}: {
  isFavorite: boolean;
}) => {
  mediator.base.dispatch({
    type: "PPM_FAVORITE_INTERACTION",
    payload: {
      isFavorite
    }
  });
};
